/* eslint-disable*/
import React from "react";
import SystemMaintenanceSpecialFunctions_MarketPriceSetup from "./MarketPriceSetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("MarketPriceSetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_MarketPriceSetup />);
    });
  });
  afterEach(cleanup);
  test("is MarketPriceSetup Loads Successfully", () => {
    expect(screen.getByText("MarketPriceSetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for MarketPriceSetup", () => {
    // START_USER_CODE-USER_MarketPriceSetup_Custom_Test_Case
    // END_USER_CODE-USER_MarketPriceSetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceSpecialFunctions_MarketPriceSetup />);
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:MarketPriceSetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:MarketPriceSetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:MarketPriceSetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:MarketPriceSetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("grpbxMarketPriceSetup(GroupBox Widget) Test Cases", async () => {
    const grpbxMarketPriceSetup = screen.getByTestId("grpbxMarketPriceSetup");
    expect(grpbxMarketPriceSetup.tagName).toBe("BUTTON");
    expect(grpbxMarketPriceSetup.type).toBe("button");
    expect(grpbxMarketPriceSetup.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxMarketPriceSetup", () => {
    // START_USER_CODE-USER_grpbxMarketPriceSetup_TEST
    // END_USER_CODE-USER_grpbxMarketPriceSetup_TEST
  });
  test("lblMarketPrice(Label Widget) Test Cases", async () => {
    const lblMarketPrice = screen.getByTestId("lblMarketPrice");
    expect(lblMarketPrice.tagName).toBe("LABEL");
    expect(lblMarketPrice.classList).toContain("form-label");
    expect(lblMarketPrice.textContent).toEqual(
      t("SystemMaintenanceSpecialFunctions:MarketPriceSetup_lblMarketPrice")
    );
  });
  test("Custom Test Cases for lblMarketPrice", () => {
    // START_USER_CODE-USER_lblMarketPrice_TEST
    // END_USER_CODE-USER_lblMarketPrice_TEST
  });
});
